import React from "react";
import userProfile from "../../assets/images/icons/userProfile.svg";
import { Breadcrumb, Col, Dropdown, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import search from "../../assets/images/icons/search.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const { authUser } = useSelector((state) => state.auth);

  // Function to format breadcrumbs in camelCase
  const formatBreadcrumb = (breadcrumb) => {
    return breadcrumb
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const readOnly = [
    "dashboards",
    "branches",
    "bookings",
    "management",
    "rewards",
  ]; // Define non-clickable breadcrumb items

  // Function to generate breadcrumbs
  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split("/").filter((x) => x);
    return (
      <Breadcrumb>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;
          const isReadOnly = readOnly.includes(value);
          return isLast || isReadOnly ? (
            <Breadcrumb.Item active={isLast ? true : false} key={to}>
              {t(formatBreadcrumb(value))}
            </Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item linkAs={Link} linkProps={{ to }} key={to}>
              {t(formatBreadcrumb(value))}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    );
  };

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    navigate(link);
  };

  return (
    <header id="page-topbar">
      <Row className="row">
        <Col md={6}>
          <div className="breadcrumb">{generateBreadcrumbs()}</div>
        </Col>
        <Col md={6}>
          <div className="g_end right_section">
            {/* <div className="searchbar position-relative">
              <img
                src={search}
                width={16}
                height={16}
                alt="search icon"
                className="search_icon"
              />
              <input type="text" placeholder={t("Search")} />
            </div> */}
            {/* <div className="divider"></div> */}
            <div className="d-flex align-items-center">
              <h2 className="user_name">
                Hello,<span>{authUser?.name || ""}</span>
              </h2>
              <Dropdown className="custom_dropdown">
                <Dropdown.Toggle>
                  <img
                    src={userProfile}
                    width={42}
                    height={42}
                    alt="user profile"
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {/* <Dropdown.Item href="#">{t("Profile")}</Dropdown.Item> */}
                  <Dropdown.Item
                    href="#"
                    onClick={(e) => handleLinkClick(e, "/logout")}
                  >
                    {t("Logout")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Col>
      </Row>
    </header>
  );
};

export default Header;
